import { OPTIMIZED_IMAGES } from "@/config/images";

// Use local, correctly sized copies in page content while retaining original
// URLs in social metadata. Width/height reserve space before the image arrives.
export const OptimizedImage = ({
  src,
  alt,
  sizes = "100vw",
  width,
  height,
  loading,
  fetchPriority,
  decoding = "async",
  ...props
}) => {
  const image = OPTIMIZED_IMAGES[src];
  return (
    <img
      {...props}
      src={image?.src || src}
      srcSet={image?.srcSet}
      sizes={image?.srcSet ? sizes : undefined}
      width={width || image?.width}
      height={height || image?.height}
      alt={alt}
      loading={loading || (fetchPriority === "high" ? "eager" : "lazy")}
      fetchPriority={fetchPriority}
      decoding={decoding}
    />
  );
};
